import env from "src/env";
import { createSession, Session } from "modules/session";
import OAuthSessionCookie from "modules/cookies/oauthcookie";
import { commonResponseHandler } from "modules/api/auth-service/common";

export type LoginParams = {
  email: string;
  password: string;
  otp?: string;
  type?: "oauth" | "dashboard";
};

export interface OAuthOtpParams {
  otp: string;
  otp_token: string;
  user_id: string;
}

export type OAuthOtpResponse =
  | {
      code: "success";
      session: string;
    }
  | {
      code: string;
      message: string;
    };

const API_URL = env.VITE_AUTH_URL;

const login = async (params: LoginParams): Promise<void> => {
  const response = await fetch(`${API_URL}/login`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(params),
  });

  const data = await commonResponseHandler<Session>({
    response,
    defaultErrorMessage: "Failed to login",
  });

  if (params.type === "oauth") {
    const request_id = new URL(window.location.href).searchParams.get(
      "request_id"
    );
    OAuthSessionCookie.save({
      request_id: request_id || "",
      regionGroups: data.regionGroups,
    });
  } else {
    createSession({
      ...data,
      signUpMethod: "email_and_password",
    });
  }
};

export const oAuthOtp = async (params: OAuthOtpParams) => {
  const defaultError = {
    code: "unexpected_failure",
    message: "The request failed unexpectedly.",
  };
  try {
    const response = await fetch(`${API_URL}/oauth/mfa`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(params),
    });
    const result = await response.text();
    if (result === "Cooldown") {
      return {
        code: "cooldown",
        message:
          "We've detected unusual activity on your account. We are blocking further requests for now.",
      };
    }
    const json = JSON.parse(result);
    if (response.status === 200) {
      return {
        code: "success",
        session: json,
      };
    } else if (json.code !== undefined && json.message !== undefined) {
      return {
        code: json.code,
        message: json.message,
      };
    }
    console.error("unexpected response", json);
  } catch (e) {
    console.error(e);
  }
  return defaultError;
};

export default login;
